import React, {
    useState
} from "react";

import {
    Bell,
    ChevronDown
} from "lucide-react";

import {
    requestPushPermission
} from "../notifications/pushNotifications";

import {
    useClinic
} from "../context/ClinicContext";

export default function MobileHeader({
    clinicData,
    onNotifications,
    notificationCount = 0
}) {

    const {
        clinicId,
        availableClinics,
        switchClinic
    } = useClinic();

    const [
        clinicSelectorOpen,
        setClinicSelectorOpen
    ] = useState(false);

    const clinicName =
        clinicData?.nombreClinica ||
        "VexaDent";

    const logoUrl =
        clinicData?.logoURL ||
        clinicData?.logoUrl ||
        clinicData?.logo ||
        "";

    return (

        <header
            className="vd-mobile-header"
            style={{
                position: "sticky",
                top: 0,
                paddingTop: "env(safe-area-inset-top)",
                zIndex: 900,
                background:
                    "rgba(255,255,255,0.97)",
                backdropFilter:
                    "blur(14px)",
                WebkitBackdropFilter:
                    "blur(14px)",
                borderBottom:
                    "1px solid #e8edf5",
                boxShadow:
                    "0 2px 12px rgba(15,23,42,0.04)"
            }}
        >

            <div
                style={{
                    minHeight: 68,
                    padding:
                        "9px 16px",
                    display: "flex",
                    alignItems:
                        "center",
                    justifyContent:
                        "space-between",
                    boxSizing:
                        "border-box"
                }}
            >

                {/* IDENTIDAD DEL CONSULTORIO */}

                <div
                    style={{
                        minWidth: 0,
                        display: "flex",
                        alignItems:
                            "center",
                        gap: 11,
                        position:
                            "relative"
                    }}
                >

                    {/* LOGO */}

                    <div
                        style={{
                            width: 44,
                            height: 44,
                            borderRadius: 12,
                            background:
                                "#ffffff",
                            border:
                                "1px solid #e7ebf2",
                            display: "flex",
                            alignItems:
                                "center",
                            justifyContent:
                                "center",
                            overflow:
                                "hidden",
                            flexShrink: 0,
                            boxShadow:
                                "0 2px 8px rgba(15,23,42,0.05)"
                        }}
                    >

                        {logoUrl ? (

                            <img
                                src={logoUrl}
                                alt={
                                    clinicName
                                }
                                style={{
                                    width:
                                        "100%",
                                    height:
                                        "100%",
                                    objectFit:
                                        "contain",
                                    padding: 5,
                                    boxSizing:
                                        "border-box"
                                }}
                            />

                        ) : (

                            <div
                                style={{
                                    width:
                                        "100%",
                                    height:
                                        "100%",
                                    display:
                                        "flex",
                                    alignItems:
                                        "center",
                                    justifyContent:
                                        "center",
                                    background:
                                        "#eff6ff",
                                    color:
                                        "#2563eb",
                                    fontSize: 19,
                                    fontWeight:
                                        800
                                }}
                            >
                                {clinicName
                                    .charAt(0)
                                    .toUpperCase()}
                            </div>

                        )}

                    </div>


                    {/* SELECTOR DEL CONSULTORIO */}

                    <div
                        style={{
                            minWidth: 0
                        }}
                    >

                        <button
                            type="button"
                            onClick={() =>
                                setClinicSelectorOpen(
                                    prev =>
                                        !prev
                                )
                            }
                            style={{
                                appearance:
                                    "none",
                                WebkitAppearance:
                                    "none",
                                border: "none",
                                padding: 0,
                                margin: 0,
                                background:
                                    "transparent",
                                display: "flex",
                                alignItems:
                                    "center",
                                gap: 5,
                                cursor:
                                    "pointer",
                                color:
                                    "#0f172a",
                                WebkitTapHighlightColor:
                                    "transparent",
                                maxWidth:
                                    "calc(100vw - 120px)"
                            }}
                        >

                            <span
                                style={{
                                    fontSize: 15,
                                    fontWeight: 750,
                                    lineHeight: 1.2,
                                    overflow:
                                        "hidden",
                                    textOverflow:
                                        "ellipsis",
                                    whiteSpace:
                                        "nowrap"
                                }}
                            >
                                {clinicName}
                            </span>

                            {availableClinics.length >
                                1 && (

                                <ChevronDown
                                    size={16}
                                    strokeWidth={2}
                                    style={{
                                        flexShrink:
                                            0,
                                        color:
                                            "#64748b",
                                        transition:
                                            "transform 0.18s ease",
                                        transform:
                                            clinicSelectorOpen
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)"
                                    }}
                                />

                            )}

                        </button>


                        <div
                            style={{
                                marginTop: 3,
                                fontSize: 10.5,
                                fontWeight: 600,
                                color:
                                    "#94a3b8",
                                letterSpacing:
                                    "0.02em"
                            }}
                        >
                            VexaDent
                        </div>

                    </div>


                    {/* MENU DE CONSULTORIOS */}

                    {clinicSelectorOpen &&
                        availableClinics.length >
                            1 && (

                        <div
                            style={{
                                position:
                                    "absolute",
                                top: 57,
                                left: 0,
                                minWidth: 230,
                                maxWidth:
                                    "calc(100vw - 32px)",
                                background:
                                    "#ffffff",
                                border:
                                    "1px solid #e5eaf2",
                                borderRadius:
                                    14,
                                boxShadow:
                                    "0 12px 30px rgba(15,23,42,0.12)",
                                padding:
                                    "6px",
                                zIndex: 1000
                            }}
                        >

                            {availableClinics.map(
                                clinic => {

                                    const name =
                                        clinic?.nombreClinica ||
                                        clinic?.nombre ||
                                        "Consultorio";

                                    const isActive =
                                        clinic.id ===
                                        clinicId;

                                    return (

                                        <button
                                            key={
                                                clinic.id
                                            }
                                            type="button"
                                            onClick={async () => {

                                                await switchClinic(
                                                    clinic.id
                                                );

                                                setClinicSelectorOpen(
                                                    false
                                                );

                                            }}
                                            style={{
                                                width:
                                                    "100%",
                                                border:
                                                    "none",
                                                background:
                                                    isActive
                                                        ? "#eff6ff"
                                                        : "#ffffff",
                                                borderRadius:
                                                    10,
                                                padding:
                                                    "10px 12px",
                                                display:
                                                    "flex",
                                                alignItems:
                                                    "center",
                                                justifyContent:
                                                    "space-between",
                                                gap: 10,
                                                textAlign:
                                                    "left",
                                                cursor:
                                                    "pointer",
                                                color:
                                                    isActive
                                                        ? "#2563eb"
                                                        : "#334155",
                                                fontSize:
                                                    13.5,
                                                fontWeight:
                                                    isActive
                                                        ? 700
                                                        : 600,
                                                WebkitTapHighlightColor:
                                                    "transparent"
                                            }}
                                        >

                                            <span
                                                style={{
                                                    overflow:
                                                        "hidden",
                                                    textOverflow:
                                                        "ellipsis",
                                                    whiteSpace:
                                                        "nowrap"
                                                }}
                                            >
                                                {name}
                                            </span>

                                            {isActive && (

                                                <span
                                                    style={{
                                                        width:
                                                            7,
                                                        height:
                                                            7,
                                                        borderRadius:
                                                            "50%",
                                                        background:
                                                            "#2563eb",
                                                        flexShrink:
                                                            0
                                                    }}
                                                />

                                            )}

                                        </button>

                                    );

                                }
                            )}

                        </div>

                    )}

                </div>


                {/* NOTIFICACIONES */}

                <button
                    type="button"
                    onClick={async () => {

                        if (typeof onNotifications === "function") {
                            onNotifications();
                        }

                        try {

                            await requestPushPermission();

                        } catch (error) {

                            console.error(
                                "Error registrando Push desde MobileHeader:",
                                error
                            );

                        }

                    }}
                    aria-label="Notificaciones"
                    style={{
                        position:
                            "relative",
                        width: 42,
                        height: 42,
                        borderRadius: 12,
                        border:
                            "1px solid #e5eaf2",
                        background:
                            "#ffffff",
                        display: "flex",
                        alignItems:
                            "center",
                        justifyContent:
                            "center",
                        cursor:
                            "pointer",
                        color:
                            "#334155",
                        flexShrink: 0,
                        boxShadow:
                            "0 2px 7px rgba(15,23,42,0.04)",
                        WebkitTapHighlightColor:
                            "transparent"
                    }}
                >

                    <Bell
                        size={21}
                        strokeWidth={1.8}
                    />

                    {notificationCount > 0 && (

                        <span
                            style={{
                                position:
                                    "absolute",
                                top: -2,
                                right: -2,
                                minWidth: 18,
                                height: 18,
                                padding:
                                    "0 4px",
                                borderRadius:
                                    999,
                                backgroundColor:
                                    "#ef4444",
                                color:
                                    "#ffffff",
                                fontSize: 10,
                                fontWeight: 700,
                                display:
                                    "flex",
                                alignItems:
                                    "center",
                                justifyContent:
                                    "center",
                                border:
                                    "2px solid #ffffff",
                                lineHeight: 1
                            }}
                        >
                            {notificationCount > 99
                                ? "99+"
                                : notificationCount}
                        </span>

                    )}

                </button>

            </div>

        </header>

    );

}
